import React, { useEffect, useState } from "react";
import "../../../style/product.css";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Input from "../../../components/Control/Input";
import useConfirm from "../../../components/Control/useConfirm";
import PublishIcon from "@material-ui/icons/Publish";
import { DatePicker } from "@material-ui/pickers";
import { useQuery } from "../../../components/Control/useQuery";

const maintenanceObj = {
  april: {
    p: false,
  },
  may: {
    p: false,
  },
  june: {
    p: false,
  },
  july: {
    p: false,
  },
  august: {
    p: false,
  },
  september: {
    p: false,
  },
  october: {
    p: false,
  },
  november: {
    p: false,
  },
  december: {
    p: false,
  },
  january: {
    p: false,
  },
  february: {
    p: false,
  },
  march: {
    p: false,
  },
};

const PlanMaintenance = ({ id, setIsMaintenanceModal }) => {
  const [maintenanceData, setMaintenanceData] = useState({
    date_range: new Date(),
  });

  const [render, setRender] = useState(false);
  const query = useQuery();
  const documentType = query.get("documentType");

  const [DialogSubmit, confirmSubmit] = useConfirm(
    "MACHINE",
    `Are you sure you want to ${id ? "update" : "save"} this part?`
  );

  useEffect(() => {
    axios
      .get(`/api/get/machine`)
      .then((res) => {
        const response = res?.data;
        maintenanceData.maintenance_list = response?.map((item) => {
          return {
            machine_id: item._id,
            ...maintenanceObj,
          };
        });
        setRender((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function handleMachineData(e) {
    setMaintenanceData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    const ans = await confirmSubmit();
    if (!ans) {
      return;
    }
    maintenanceData.document_type = documentType;
    if (id) {
      await axios
        .put(`/api/updatePreventive/${id}`, maintenanceData)
        .then((res) => {
          setIsMaintenanceModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post("/api/create/preventive", maintenanceData)
        .then((res) => {
          setIsMaintenanceModal(false);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className="root-admin">
      <form
        style={{
          margin: "1.8rem",
        }}
        onSubmit={(e) => onSubmit(e)}
      >
        <div className="supplier-section">
          <section className="supplier-section-part">
            <Input
              label="Title"
              name="title"
              type="text"
              onChange={handleMachineData}
              value={maintenanceData.title}
              required
            />
            <DatePicker
              label="Date Range"
              views={["year"]}
              className="date-field"
              inputVariant="filled"
              clearable
              onChange={(date) => {
                setMaintenanceData((prev) => ({ ...prev, date_range: date }));
              }}
              style={{ marginTop: "0.6rem" }}
              value={maintenanceData.date_range}
            />
          </section>
          <div
            className="btn_save"
            style={{
              position: "absolute",
              right: "150px",
              top: "9px",
            }}
          >
            <Button
              type="submit"
              variant="outlined"
              color="white"
              size="large"
              style={{ color: "#e9e9e9" }}
              startIcon={<PublishIcon />}
            >
              {id ? "UPDATE" : "SUBMIT"}
            </Button>
          </div>
        </div>
      </form>
      <DialogSubmit isSubmitContent={false} />
    </div>
  );
};

export default PlanMaintenance;
